import { render, staticRenderFns } from "./SZlifePetInfoDoenca.vue?vue&type=template&id=abdb6d90&scoped=true"
import script from "./SZlifePetInfoDoenca.vue?vue&type=script&lang=js"
export * from "./SZlifePetInfoDoenca.vue?vue&type=script&lang=js"
import style0 from "./SZlifePetInfoDoenca.vue?vue&type=style&index=0&id=abdb6d90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abdb6d90",
  null
  
)

export default component.exports